import moment from 'moment'
 
export const decimalHours = hoursMinutes => {
    const parts = hoursMinutes.split(":")
    if( parts.length===0 ) return 0;

    let decHours = 0
    decHours += parts.length > 0 && !isNaN(parseInt(parts[0])) ? parseInt(parts[0]) : 0
    decHours += parts.length > 1 && !isNaN(parseInt(parts[1])) ? parseInt(parts[1])/60 : 0
    decHours += parts.length > 2 && !isNaN(parseInt(parts[2])) ? parseInt(parts[2])/60/60 : 0

    return decHours;
}

export const deconstructDecimalTime = decimalHours => {
    const hours = Math.floor(decimalHours)
    const minutes = Math.floor((decimalHours - hours)*60) 
    const secondsRound = Math.round( decimalHours*3600-hours*3600-minutes*60 )                                                                                                                                                                                                                        

    return({hours: hours, minutes: secondsRound === 60 ? minutes+1 : minutes, seconds: secondsRound === 60 ? 0 : secondsRound});
}

export const rangeFromYearAndMonth = (year,month) => {
    const afterMonth = month === "All" ? 1 : parseInt(month)
    const beforeMonth = month === "All" ? 12 : parseInt(month)
    const afterDate = moment("2019-01-01T00:00:00").year(year).month(afterMonth-1).date(1).format()
    const beforeDate = moment("2019-01-01T00:00:00").year(year).month(beforeMonth).date(1).format()
    return({start:afterDate, end:beforeDate});
}

export const rangeBeforeWithDurationInMonths = (months,offsetFromNow=0,earliestStartDate=null) => {
    const now = offsetFromNow === 0 ? moment() : moment().subtract('months',offsetFromNow);
    const startDate =  moment().subtract('months',months+offsetFromNow);
    return({
        start: earliestStartDate && moment(earliestStartDate).isAfter(startDate) ? moment(earliestStartDate).format() : startDate.format(), 
        end:now.format()
    });
}

export const totalTime = (events,perUser = false) => {
    return events.reduce( (total, event) => {
        if(event.hidden || isNaN(parseFloat(event.totalHours))) return total;
        const totalHours = parseFloat(event.totalHours)
        const assigneeCount = Array.isArray(event.assigneeIds) ? event.assigneeIds.length : 0
        return (perUser && assigneeCount > 0 ? totalHours / assigneeCount : totalHours) + total;
    }, 0)
}
